var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.62398 3.46338V11.1976H8.79202V4.63523H6.41599V11.1976H5.58401V5.80711H3.20798V11.1977H2.376V6.97896H0V11.9008H12V3.46338H9.62398ZM1.67292 11.1976H0.703125V7.68208H1.67292V11.1976ZM4.88088 11.1976H3.91111V6.51021H4.88088V11.1976ZM8.08889 11.1976H7.11912V5.33836H8.08889V11.1976ZM11.2969 11.1976H10.3271V4.1665H11.2969V11.1976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3575 0.0991211L9.98739 0.696965L10.7404 1.16307L0.0209656 5.0498L0.260661 5.71083L10.9612 1.83094L10.6383 2.65329L11.2928 2.91019L11.9978 1.11448L10.3575 0.0991211Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarGraph);
export default __webpack_public_path__ + "static/media/bar-graph.76d82806f4137c55afb19ebd96161d01.svg";
export { ForwardRef as ReactComponent };